import component from "containers/StaticPages/pages/EnterpriseSignup";

export default {
  key: "enterprise-signup",
  title: "Enterprise Signup",
  path: "/:user?/enterprise/signup",
  pageName: "enterpriseSignup",
  linkTarget: "/enterprise/signup",
  exact: true,
  component,
};
